import clsx from 'clsx';
import { Flex } from '@nula/core-ui';
import styles from './generating-dot.module.css';

interface GeneratingDotProps {
  className?: string;
}

export function GeneratingDot({ className }: GeneratingDotProps) {
  return <Flex component="span" role="img" aria-label="Generating" className={clsx(styles.dot, className)} />;
}
